import { c as _c } from "react/compiler-runtime";
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
export const useInterruptSpitTest = mailingSplitTestId => {
  const $ = _c(4);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      method: RequestMethodsEnum.post
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    fetcher
  } = useFetch(t0);
  let t1;
  if ($[1] !== fetcher || $[2] !== mailingSplitTestId) {
    t1 = () => mailingSplitTestId && fetcher(`/api/dashboard/mailing-service/split-test/${mailingSplitTestId}/interrupt`);
    $[1] = fetcher;
    $[2] = mailingSplitTestId;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};